// extracted by mini-css-extract-plugin
export default {"container":"NL-z","topReviewHeading":"OL-z","criticalReview":"PL-z","favorableReview":"QL-z","vsSeparator":"RL-z"};